module.exports = __webpack_public_path__ + "img/orange-circle-table-1.e14f5321.png";